import { UtilsIdentifier } from "@hotelchamp/common";
import { format } from "date-fns";

import { IIbeConfig } from "../../types";

export const ibeConfigToUrlParams = (config: IIbeConfig): URLSearchParams => {
    const params = new URLSearchParams();

    params.set("p", "base");

    const { checkin, checkout, adultCount, infantCount, childCount, roomCount, promoCode, languageCode, propertyId } = config;

    if (checkin && checkout) {
        params.set("d", `${format(checkin, "yyyy-MM-dd")},${format(checkout, "yyyy-MM-dd")}`);
    }

    // Generate booking rooms based on roomCount
    const brParams = [];
    for (let i = 0; i < (roomCount || 1); i++) {
        brParams.push(`${UtilsIdentifier.uniqueString()},_,_,_,${adultCount || 2},1:${infantCount || 0},2:${childCount || 0}`);
    }
    // Set a single 'br' parameter with all room bookings joined by semicolons
    if (brParams.length > 0) {
        params.set("br", brParams.join(";"));
    }

    if (promoCode) {
        params.set("pc", promoCode);
    }

    if (languageCode) {
        params.set("lg", languageCode);
    }

    if (checkin && checkout && adultCount) {
        params.set("c", "availability");
    } else {
        params.set("c", "search");
    }

    return params;
};
